var Backbone, SpinnerTemplate, SpinnerView;

Backbone = require('backbone');

SpinnerTemplate = require('../../spinner.html.mustache');

module.exports = SpinnerView = Backbone.View.extend({
  template: SpinnerTemplate,
  initialize: function(arg) {
    var ref;
    this.parentElem = arg.parentElem, this.css = arg.css, this.useV2 = arg.useV2;
    return (ref = this.parentElem) != null ? typeof ref.append === "function" ? ref.append(this.$el) : void 0 : void 0;
  },
  render: function() {
    this.stop();
    this.$el.html(this.template.render({
      useV2: this.useV2
    }));
    if (this.useV2) {
      if (this.css != null) {
        this.$el.find('.g-spinner').css(this.css);
      }
    } else {
      if (this.css != null) {
        this.$el.find('.t-spinner-small').css(this.css);
      }
    }
    return this;
  },
  isRunning: function() {
    return this.$el.is(':visible');
  },
  isInDom: function() {
    return $.contains(document.documentElement, this.$el[0]);
  },
  start: function() {
    var ref;
    if (!this.isInDom()) {
      if ((ref = this.parentElem) != null) {
        if (typeof ref.append === "function") {
          ref.append(this.$el);
        }
      }
    }
    return this.$el.show();
  },
  stop: function() {
    return this.$el.hide();
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9zcGlubmVyL2Zyb250ZW5kL3ZpZXdzL3NwaW5uZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9zcGlubmVyL2Zyb250ZW5kL3ZpZXdzL3NwaW5uZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLGVBQUEsR0FBa0IsT0FBQSxDQUFRLDZCQUFSOztBQUVsQixNQUFNLENBQUMsT0FBUCxHQUFpQixXQUFBLEdBQWMsUUFBUSxDQUFDLElBQUksQ0FBQyxNQUFkLENBQzdCO0VBQUEsUUFBQSxFQUFVLGVBQVY7RUFFQSxVQUFBLEVBQVksU0FBQyxHQUFEO0FBQ1YsUUFBQTtJQURZLElBQUMsQ0FBQSxpQkFBQSxZQUFZLElBQUMsQ0FBQSxVQUFBLEtBQUssSUFBQyxDQUFBLFlBQUE7bUZBQ3JCLENBQUUsT0FBUSxJQUFDLENBQUE7RUFEWixDQUZaO0VBS0EsTUFBQSxFQUFRLFNBQUE7SUFDTixJQUFDLENBQUEsSUFBRCxDQUFBO0lBQ0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsSUFBQyxDQUFBLFFBQVEsQ0FBQyxNQUFWLENBQWlCO01BQUUsT0FBRCxJQUFDLENBQUEsS0FBRjtLQUFqQixDQUFWO0lBQ0EsSUFBRyxJQUFDLENBQUEsS0FBSjtNQUNFLElBQXFDLGdCQUFyQztRQUFBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLFlBQVYsQ0FBdUIsQ0FBQyxHQUF4QixDQUE0QixJQUFDLENBQUEsR0FBN0IsRUFBQTtPQURGO0tBQUEsTUFBQTtNQUdFLElBQTJDLGdCQUEzQztRQUFBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLGtCQUFWLENBQTZCLENBQUMsR0FBOUIsQ0FBa0MsSUFBQyxDQUFBLEdBQW5DLEVBQUE7T0FIRjs7V0FJQTtFQVBNLENBTFI7RUFjQSxTQUFBLEVBQVcsU0FBQTtXQUNULElBQUMsQ0FBQSxHQUFHLENBQUMsRUFBTCxDQUFRLFVBQVI7RUFEUyxDQWRYO0VBaUJBLE9BQUEsRUFBUyxTQUFBO1dBQ1AsQ0FBQyxDQUFDLFFBQUYsQ0FBVyxRQUFRLENBQUMsZUFBcEIsRUFBcUMsSUFBQyxDQUFBLEdBQUksQ0FBQSxDQUFBLENBQTFDO0VBRE8sQ0FqQlQ7RUFvQkEsS0FBQSxFQUFPLFNBQUE7QUFDTCxRQUFBO0lBQUEsSUFBNkIsQ0FBSSxJQUFDLENBQUEsT0FBRCxDQUFBLENBQWpDOzs7YUFBVyxDQUFFLE9BQVEsSUFBQyxDQUFBOztPQUF0Qjs7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBQTtFQUZLLENBcEJQO0VBd0JBLElBQUEsRUFBTSxTQUFBO1dBQ0osSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQUE7RUFESSxDQXhCTjtDQUQ2QiJ9
